import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";

import AppleLoginButton from "react-apple-login";

//
import { Button, Spinner } from "react-bootstrap";

import Apple from "../../assets/img/apple-black.svg";

//
import { appleLogin } from "../../redux/features/user/actions";
import { setUser } from "../../redux/features/user/slice";

function AppleLogin({ text, setUser }) {
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  // Get query from url
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  let query = useQuery();

  let referral = query.get("referral");

  const appleResponse = async (response) => {
    if (response.authorization) {
      // start loading
      setLoading(true);

      // variables
      let content = {
        token: response.authorization.id_token,
      };
      if (referral) {
        content.referral = referral;
      }

      // request
      await appleLogin(content).then((res) => {
        if (res) {
          setUser(res);
          setLoading(false);
          navigate("/");
        }
      });

      // stop loading
      setLoading(false);
    }
  };

  return (
    <AppleLoginButton
      clientId="com.invalert.invalertapp.sid"
      redirectURI="https://panel.invalert.com"
      usePopup={true}
      callback={appleResponse}
      scope="email name"
      responseMode="query"
      render={(renderProps) => (
        <Button
          onClick={renderProps.onClick}
          size="lg"
          type="button"
          variant="warning"
          className="w-100 d-flex align-items-center justify-content-center m-0"
        >
          <img alt="Logo" src={Apple} className="me-3" height="20px" />

          {text}
          {loading && (
            <div className="spinner-holder">
              <Spinner animation="border" variant="white" size="sm" />
            </div>
          )}
        </Button>
      )}
    />
  );
}

AppleLogin.propTypes = {
  text: PropTypes.string.isRequired,
  setUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setUser,
};

export default connect(null, mapDispatchToProps)(AppleLogin);
